<template>
  <div v-loading="isLoading">
    <div class="contract-viewer-summary">
      <div>
        <i class="el-icon-warning"></i>
        <span>下列表格中是您尚未签署的上课形式与回放规则须知. 在&nbsp;"签署"&nbsp;列的方框中勾选即视为您同意此上课形式与回放规则须知的全部内容.</span>
      </div>
    </div>
    <el-table :data="contractList" style="width: 100%;"  class="contract-viewer-table" empty-text="暂无待签署的上课形式与回放规则须知">
      <el-table-column prop="CourseName" label="课程" width="180"></el-table-column>
      <!-- <el-table-column prop="ContractDescription" label="上课形式与回放规则须知" width="120"></el-table-column> -->
      <el-table-column label="文本" width="100">
        <template slot-scope="scope">
          <ul>
            <li v-for="(item, index) in scope.row.FilePaths" :key="item">
              <el-button type="text" @click="onClickDownloadContract(item)">
                查看
                <span v-if="scope.row.FilePaths.length > 1">{{index + 1}}</span>
              </el-button>
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column label="签署">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.IsAccepted"> 我同意此上课形式与回放规则须知的全部内容</el-checkbox>
        </template>
      </el-table-column>
    </el-table>
    <div class="contract-viewer-footer">
      <el-button type="primary" size="medium" :disabled="submitInProgress" :loading="submitInProgress" v-on:click="commit">提交</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .contract-viewer-summary{
    .contract-viewer-summary-payment{
      display: block;
      margin-left: 20px;
    }
  }
  .contract-viewer-table{

    ul {
      list-style-type: none;
      padding-left: 3px;
      margin-bottom: 0;
    }

    .el-checkbox{
      margin-bottom: 0;
    }
  }

  .contract-viewer-footer {
    text-align: center;
    margin-top: 20px;
  }


</style>

<script>
import {
  openLink
} from "@/config/mUtils";
import {
  getUncheckedStudentSpeedupCourseReplayRules,
  signStudentSpeedupCourseReplayRules
} from "../../service/contract.service";

export default {
  data() {
    return {
      contractList: [],
      submitInProgress: false,
      isLoading: false
    };
  },
  props: {
  },
  updated() {},
  created() {
    this.isLoading = true;
    getUncheckedStudentSpeedupCourseReplayRules().then((rs) => {
      if(rs != null && rs.success && rs.data.length > 0) {
        this.contractList = rs.data;
      }else{
        this.contractList = [];
      }

      this.isLoading = false;
    });

  },
  methods: {
    async commit() {
      if (this.contractList.length == 0){
        this.$emit("contractSigned");
        return;
      }
      let unacceptedItems = this.contractList.filter((i) => !i.IsAccepted);
      let acceptedItems = this.contractList.filter((i) => i.IsAccepted);
      let studentSpeedupCourseIds = acceptedItems.map(i => i.StudentSpeedupCourseId).flat();

      if(unacceptedItems.length > 0) {
        let courseNames = unacceptedItems.map(i => i.CourseName);
        let desc = "";
        if (courseNames.length > 0){
          if (desc){
            desc += ", ";
          }
          desc += "课程(" + courseNames.join(",") + ")";
        }
        this.$message.warning(`您没有签署${desc}的对应上课形式与回放规则须知, 请您仔细阅读上课形式与回放规则须知后勾选再提交.`);
        return;
      }

      try
      {
        this.submitInProgress = true;
        let result = await signStudentSpeedupCourseReplayRules(studentSpeedupCourseIds);
        if (!result.success){
          this.$message.error(result.message);
          return;
        }

        this.$message.success("签署成功.");
        this.$emit("contractSigned");
      }
      finally{
        this.submitInProgress = false;
      }
    },
    onClickDownloadContract(link){
      openLink(link);
    }
  },
  computed: {
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/contract/courseReplayRuleViewer.vue